<script setup>
  import MedicationComponentIndicationCheckboxRow from "@pages/Records/Components/Sections/MedicationBar/Components/Indications/IndicationCheckboxRow.vue";
  import {cloneDeep} from "es-toolkit";

  defineOptions({
    name: "MedicationComponentIndicationCheckbox",
  });

  const props = defineProps({
    type: {
      type: String,
      default: "default",
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    indicationsOptions: {
      type: Object,
      default: () => ({}),
    },
    newIndicationList: {
      type: Object,
      require: true,
      default: () => ({}),
    },
    indicationsUnknown: {
      type: Boolean,
      required: true,
    },
    hashId: {
      type: String,
      required: true,
    },
  });

  const emit = defineEmits(["formChange"]);

  const setIndication = (newValue, newIndication) => {
    let currentIndications = cloneDeep(props.newIndicationList);

    if (currentIndications.length > 0) {
      if (newValue) {
        const check = currentIndications.some(
          (indication) => indication.abdata_key_miv === newIndication.abdata_key_miv,
        );

        if (check) return;

        currentIndications.push(newIndication);
      } else {
        currentIndications = currentIndications.filter((indication) => {
          return indication.abdata_key_miv !== newIndication.abdata_key_miv;
        });
      }
    } else {
      currentIndications.push(newIndication);
    }

    emit("formChange", {key: "indications", newValue: currentIndications});
  };

  const isChecked = (indication) => {
    return props.newIndicationList.some(
      (checkedIndications) => checkedIndications.abdata_key_miv === indication.abdata_key_miv,
    );
  };
</script>

<template>
  <div class="flex flex-col gap-2 pb-2">
    <template
      v-for="(indication, index) in indicationsOptions"
      :key="indication.abdata_key_miv + '.' + hashId + '-' + index"
    >
      <MedicationComponentIndicationCheckboxRow
        ref="selectList"
        :is-checked="isChecked(indication)"
        :data-hash-id="hashId"
        :indication-data="indication"
        :test-id="getTestId(`${index}`)"
        @set-indication="setIndication"
      />
    </template>
  </div>
</template>
